import { usePage } from '@inertiajs/react';
/**
 * Permissões do usuário pelo nome usado no Laravel (@can('project-edit')).
 * A tela só esconde o que a pessoa não pode usar: quem decide é sempre o
 * middleware permission:x da rota.
 */
export function useCan() {
    const { panel } = usePage().props;
    const abilities = (panel === null || panel === void 0 ? void 0 : panel.abilities) || [];
    return (...names) => names.every((name) => abilities.includes(name));
}
